import FeatureGate from '@atlaskit/feature-gate-js-client';

function isAnalyticsEventsMigrated() {
	return (
		FeatureGate.initializeCompleted() &&
		FeatureGate.checkGate('ptc-enable-people-teams-ui-analytics-refactor')
	);
}

export { isAnalyticsEventsMigrated };
